export default __webpack_public_path__ + "static/media/gw.ddffa763.svg";